import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminForgotPassword, adminResetPassword } from "../../../helpers/apis";
import { showToast } from "../../toast/reducer";

export const forgotPassword = createAsyncThunk(
    'forgotPassword/forgotPassword',
    async (data, thunkAPI) => {
        try {
            const response = await adminForgotPassword(data);

            // Handle API response structure: { statusCode, status, message }
            if (response && response.status === 1) {
                const message = response.message || "Password reset email sent successfully";
                thunkAPI.dispatch(showToast({ type: "success", msg: message }));
                return message;
            } else {
                const errorMsg = response?.message || "Failed to send password reset email";
                thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
                return thunkAPI.rejectWithValue(errorMsg);
            }
        } catch (error) {
            const errorMsg = error?.message || "An error occurred";
            thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
            return thunkAPI.rejectWithValue(errorMsg);
        }
    }
);

export const resetPassword = createAsyncThunk(
    'forgotPassword/resetPassword',
    async (data, thunkAPI) => {
        try {
            const response = await adminResetPassword(data);

            // Handle API response structure: { statusCode, status, message }
            if (response && response.status === 1) {
                const message = response.message || "Password reset successful";
                thunkAPI.dispatch(showToast({ type: "success", msg: message }));
                return message;
            } else {
                const errorMsg = response?.message || "Failed to reset password";
                thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
                return thunkAPI.rejectWithValue(errorMsg);
            }
        } catch (error) {
            const errorMsg = error?.message || "An error occurred";
            thunkAPI.dispatch(showToast({ type: "error", msg: errorMsg }));
            return thunkAPI.rejectWithValue(errorMsg);
        }
    }
);
